export const COPY_SONAR_OBJECT_BASE = {
	APEX_CLASS: 'Apex Class',
	APEX_TRIGGER: 'Apex Trigger',
	AUTOMATION_RULE: 'Automation Rule',
	EMAIL: 'Email',
	EMAIL_ALERT: 'Email Alert',
	EMAIL_TEMPLATE: 'Email Template',
	FIELD: 'Field',
	FIELD_UPDATE: 'Field Update',
	FLOW: 'Flow',
	FORM: 'Form',
	FORMULA_FIELD: 'Formula Field',
	LANDING_PAGE: 'Landing Page',
	LIST: 'List',
	OBJECT: 'Object',
	PAGE_ACTION: 'Page Action',
	PAGE_LAYOUT: 'Page Layout',
	PICKLIST_VALUE: 'Picklist Value',
	PROCESS_BUILDER: 'Process Builder',
	PROFILE: 'Profile',
	REPORT: 'Report',
	TAG: 'Tag',
	VALIDATION_RULE: 'Validation Rule',
	WORKFLOW_ACTION: 'Workflow Action',
	WORKFLOW_RULE: 'Workflow Rule'
} as const;

export const COPY_SONAR_OBJECT_BASE_PLURAL = {
	APEX_CLASS: `${COPY_SONAR_OBJECT_BASE.APEX_CLASS}es`,
	APEX_TRIGGER: `${COPY_SONAR_OBJECT_BASE.APEX_TRIGGER}s`,
	AUTOMATION_RULE: `${COPY_SONAR_OBJECT_BASE.AUTOMATION_RULE}s`,
	EMAIL: `${COPY_SONAR_OBJECT_BASE.EMAIL}s`,
	EMAIL_ALERT: `${COPY_SONAR_OBJECT_BASE.EMAIL_ALERT}s`,
	EMAIL_TEMPLATE: `${COPY_SONAR_OBJECT_BASE.EMAIL_TEMPLATE}s`,
	FIELD: `${COPY_SONAR_OBJECT_BASE.FIELD}s`,
	FIELD_UPDATE: `${COPY_SONAR_OBJECT_BASE.FIELD_UPDATE}s`,
	FLOW: `${COPY_SONAR_OBJECT_BASE.FLOW}s`,
	FORM: `${COPY_SONAR_OBJECT_BASE.FORM}s`,
	FORMULA_FIELD: `${COPY_SONAR_OBJECT_BASE.FORMULA_FIELD}s`,
	LANDING_PAGE: `${COPY_SONAR_OBJECT_BASE.LANDING_PAGE}s`,
	LIST: `${COPY_SONAR_OBJECT_BASE.LIST}s`,
	OBJECT: `${COPY_SONAR_OBJECT_BASE.OBJECT}s`,
	PAGE_ACTION: `${COPY_SONAR_OBJECT_BASE.PAGE_ACTION}s`,
	PAGE_LAYOUT: `${COPY_SONAR_OBJECT_BASE.PAGE_LAYOUT}s`,
	PICKLIST_VALUE: `${COPY_SONAR_OBJECT_BASE.PICKLIST_VALUE}s`,
	PROCESS_BUILDER: `${COPY_SONAR_OBJECT_BASE.PROCESS_BUILDER}s`,
	PROFILE: `${COPY_SONAR_OBJECT_BASE.PROFILE}s`,
	REPORT: `${COPY_SONAR_OBJECT_BASE.REPORT}s`,
	TAG: `${COPY_SONAR_OBJECT_BASE.TAG}s`,
	VALIDATION_RULE: `${COPY_SONAR_OBJECT_BASE.VALIDATION_RULE}s`,
	WORKFLOW_ACTION: `${COPY_SONAR_OBJECT_BASE.WORKFLOW_ACTION}s`,
	WORKFLOW_RULE: `${COPY_SONAR_OBJECT_BASE.WORKFLOW_RULE}s`
} as const;
